// General api to access data
import { INTEGRATION_API_URL, CHAT_BOT_URL } from '../env';

const api = (path, params, method, token, domainUrl) => {
  let options;
  options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      applicationid:20000,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    method: method,
    ...(params && { body: JSON.stringify(params) }),
  };
  let baseUrl = domainUrl ? domainUrl : INTEGRATION_API_URL;
  //console.log('baseUrl', baseUrl + path, params, options);
  return fetch(baseUrl + path, options)
    .then(resp => {
      return resp;
    })
    .catch(error => error);
};
export default api;

// const api = (path, params, method, token, domainUrl) => {
//   let options;
//   options = {
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//       ...(token && { Authorization: `Bearer ${token}` }),
//       },
//     method: method,
//     'X-AUTH-TOKEN': token,
//     ...(params && { body: JSON.stringify(params) }),
//   };
//   let baseUrl = domainUrl ? domainUrl : INTEGRATION_API_URL;
//   console.log('baseUrl', baseUrl + path, params, options);
//   return fetch(baseUrl + path, options)
//     .then(resp => {
//       return resp;
//     })
//     .catch(error => error);
// };
// export default api;
